import React from "react";
import Phone from "../../assets/landingPage/phone.jsx";
import Email from "../../assets/landingPage/email.jsx";

const AgentSidebar = (props) => {
  return (
    <div className="sm:sticky top-[10px] bg-white shadow-lg rounded-xl py-[60px] px-[10px] border border-gray-200 font-inter mr-[40px]">
      {/* Agent Info */}
      <div className="flex flex-row items-center text-center mx-[30px]">
        <img src={props.imageURL ? props.imageURL : '/profile-avatar.jpg'} alt="Agent" className="w-[70px] h-[70px] rounded-full mr-[10px]" />
        <div className="flex flex-col text-left">
        <h3 className="text-lg font-semibold mt-2 text-[#344054] leading-[20px]">{props.agentName}</h3>
        <p className="text-sm text-[#667085]">Listing Agent</p>
        </div>
      </div>

      {/* Contact Options */}
      <div className="mt-4 mx-[30px]">
        <a href={props.phoneNumber ? props.phoneNumber : "tel:(904)650-3761"} className="text-[#0062ff] border-[2px] border-[#0062ff] px-5 py-4 rounded-full text-center flex gap-2 justify-center tracking-[2px]">
          <Phone className=""/> Call {props.phoneNumber ? props.phoneNumber : "(904) 650-3761"}
        </a>
          <a href={props.emailAddress ? `mailto:${props.emailAddress}` : 'example@mail.com' } className="flex w-full text-white bg-[#0062ff] mx-auto px-5 py-4 rounded-full mt-3 gap-4 justify-center tracking-[2px]">
            <Email className=""/> Send Email
            </a>
      </div>
    </div>
  );
};

export default AgentSidebar;
